module.exports = __webpack_public_path__ + "static/media/default.19d67f24f44d6d0e070d06e3468456c9.png";